module.exports = __webpack_public_path__ + "static/img/1-2.4e87f9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/1-2.png
// module id = aApW
// module chunks = 0